// This is testing
// export const FIREBASE_CONFIG = {
//   apiKey: "AIzaSyB2HtFeY9XBq3EJFiGLM1c0BGeaa5rvi-k",
//   authDomain: "praxis-6b6a8.firebaseapp.com",
//   databaseURL: "https://praxis-6b6a8-default-rtdb.firebaseio.com",
//   projectId: "praxis-6b6a8",
//   storageBucket: "praxis-6b6a8.appspot.com",
//   messagingSenderId: "516717977820",
//   appId: "1:516717977820:web:cbd19e9a8723d82a81d419",
//   measurementId: "G-ME13MESMLC"
// };

// This is prod
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDituqcdpho7Yo9EVzvVFKgJYFphLfJNWc",
  databaseURL: "https://fyneai-apps-default-rtdb.firebaseio.com",
  authDomain: "fyneai-apps.firebaseapp.com",
  projectId: "fyneai-apps",
  storageBucket: "fyneai-apps.firebasestorage.app",
  messagingSenderId: "653202191186",
  appId: "1:653202191186:web:12c9baafb94f7b3fb8008b",
  measurementId: "G-5HK6PSY49W"
};
